import { render, staticRenderFns } from "./ClientReviewLayout.vue?vue&type=template&id=e2a48cec&"
import script from "./ClientReviewLayout.vue?vue&type=script&lang=ts&"
export * from "./ClientReviewLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ClientReviewLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports